import { AxiosResponse } from 'axios';

import { useQueryClient } from '@tanstack/react-query';

import { axiosInstance } from '~/services/fetchServiceV2';
import { TypeErrorFormat, requestHelper } from '~/utils/fetchHelper';

/**
 * @description 근로계약서 파일 다운로드 api 요청에 사용되는 커스텀 훅
 */
export const useDownloadContractFile = () => {
  const queryClient = useQueryClient();

  const requestDownloadContractFile = async ({
    id,
    onSuccess,
    onError,
  }: {
    id: string;
    onSuccess: (response: AxiosResponse) => void;
    onError?: (error: TypeErrorFormat) => void;
  }) => {
    const endpoint = `/labor/contracts/${id}/download`;
    const query = queryClient.ensureQueryData({
      queryKey: ['contracts', 'download', id],
      queryFn: () => axiosInstance.get(endpoint, { headers: { isFileDownload: true } }),
      gcTime: 0,
    });

    return requestHelper(() => query, onSuccess, onError, undefined, { showLoading: true, isFileDownload: true });
  };

  return requestDownloadContractFile;
};
